import { Team } from '@clearkit/icons';

import { TeamUserSettings } from '~/components/profile/TeamUserSettings';
import { PageLayout } from '~/components/unified/PageLayout';

export const PageTeamUsers = () => (
  <PageLayout>
    <PageLayout.Header>
      <PageLayout.Tile>
        <Team />
      </PageLayout.Tile>
      <PageLayout.Heading>Users</PageLayout.Heading>
      <PageLayout.SubHeading>Manage your team membership</PageLayout.SubHeading>
    </PageLayout.Header>
    <PageLayout.Body>
      <PageLayout.Content>
        <TeamUserSettings />
      </PageLayout.Content>
    </PageLayout.Body>
  </PageLayout>
);
